import React from "react";

const TitleHeading = ({ title, className }) => {
	return (
		<h1
			className={`text-2xl font-bold mb-4 overflow-hidden text-gray-300 ${className}`}
		>
			{title}
		</h1>
	);
};

export default TitleHeading;
